import { useEffect, useState } from "react";
import dingLogoImage from "@/assets/ding-logo-transparent.png"

const navLinks = [
  { label: "Home", href: "#hero" },
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-ding-black/90 backdrop-blur-md border-b border-ding-lightgray"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8 lg:px-16 py-4 flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex items-center">
          <img
            src={dingLogoImage}
            alt="d!ng"
            className="w-20 h-auto"
          />
        </a>

        {/* Nav Links */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              className="text-sm font-mono text-ding-dim hover:text-ding-phosphor transition-colors duration-300 whitespace-nowrap"
              key={link.href}
              href={link.href}
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* Mobile menu button */}
        <div className="relative">
          <button className="md:hidden w-10 h-10 flex items-center justify-center text-ding-cream"
            onClick={toggleMenu}
          >
            <i className="ri-menu-line text-xl"></i>
          </button>

          {isMenuOpen && (
            <div className="absolute -left-10 border-2 border-solid border-ding-lightgray bg-black text-ding-cream">
              <ul>
              {navLinks.map((link) =>
                  <li className="text-lg font-mono text-ding-dim hover:text-ding-phosphor transition-colors duration-300 whitespace-nowrap" key={link.href}
                  onClick={toggleMenu}>
                      <a href={link.href}>{link.label}</a>
                </li>
                )}
              </ul>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}